<section class="notifications card">
    <button
        class="button__add button button_size_small button_theme_comment button_icon-only"
        [ngClass]="{ button_theme_task: notificationTab }"
        (click)="addNewButtonClick()"
        [disabled]="isDisabled(27)"
    >
        <i class="fa-solid fa-plus"></i>
    </button>
    <p-tabView class="notification-tabview" [activeIndex]="notificationTab" (onChange)="changeNotificationTab()">
        <p-tabPanel class="comments custom-scrollbar" [ngClass]="{ tabpanel_hidden: notificationTab }" [selected]="true">
            <ng-template pTemplate="header">
                <button class="button button_size_small button_theme_gray button_with-icon" [ngClass]="{ button_theme_comment: hasComments() }">
                    הערות
                    <i class="fa-regular fa-pen"></i>
                </button>
            </ng-template>
            <div
                class="panel"
                #commentPanel
                [ngStyle]="{ 'background-color': getBackgroundColor(item.color) }"
                @panelAnimation
                [@.disabled]="isNotificationsAnimationDisabled"
                *ngFor="let item of getNotificationsArray()"
                (click)="editExistingComment(item)"
            >
                <div class="panel__header">
                    <h4 class="panel__title">{{ item.title }}</h4>
                    <div class="panel__date">
                        <span class="date__text">{{ item.dateRegistrationText }} </span>
                        <span class="date__number">{{ item.dateRegistrationInSideText }}</span>
                    </div>
                    <button class="panel__cross" (click)="crossButtonClick(item); stopPropagation($event)" [disabled]="isDisabled(28)">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="panel__comment custom-scrollbar">
                    {{ item.comments }}
                </div>
                <div class="panel__footer">
                    <span class="panel__corner-wrapper">
                        <span class="panel__corner" [ngStyle]="{ 'background-color': item.color }"></span>
                    </span>

                    <button
                        *ngIf="!item.isChecked"
                        class="panel__button button__pin"
                        (click)="pinButtonClick(item); stopPropagation($event)"
                        [disabled]="isDisabled(32)"
                    >
                        <i class="fa-regular fa-thumbtack"></i>
                    </button>

                    <button
                        *ngIf="item.isChecked"
                        class="panel__button button__pin button__pin_active"
                        (click)="pinButtonClick(item); stopPropagation($event)"
                        [disabled]="isDisabled(32)"
                    >
                        <i class="fa-solid fa-thumbtack"></i>
                    </button>

                    <button class="panel__button button__bell" (click)="switchToTask(item); stopPropagation($event)" [disabled]="isDisabled(30)">
                        <i class="fa-regular fa-bell"></i>
                    </button>

                    <span *ngIf="isReadMoreButtonVisible(commentPanel)" class="panel__read-more">קרא עוד...</span>
                </div>
            </div>

            <div *ngIf="!hasComments()" class="panel__empty">
                <span class="panel__empty-text">לא נמצאו הערות, אם ברצונך להוסיף הערה חדשה אנא השתמש בסמל הפלוס</span>
                <span class="panel__empty-image panel__empty-image-comment"></span>
            </div>

            <div class="panel__loader-wrapper" [ngClass]="{ 'panel__loader-wrapper_visible': isLoaderVisible }">
                <span class="panel__loader"></span>
            </div>
        </p-tabPanel>
        <p-tabPanel class="tasks custom-scrollbar" [ngClass]="{ tabpanel_hidden: !notificationTab }">
            <ng-template pTemplate="header">
                <button class="button button_size_small button_theme_gray button_with-icon" [ngClass]="{ button_theme_task: hasTasks() }">
                    מטלות
                    <i class="fa-solid fa-list-check"></i>
                </button>
            </ng-template>
            <div
                class="panel"
                [ngClass]="{ panel_inactive: !item.inAction }"
                @panelAnimation
                [@.disabled]="isNotificationsAnimationDisabled"
                *ngFor="let item of getNotificationsArray()"
                (click)="editExistingTask(item)"
            >
                <div class="panel__header">
                    <h4 class="panel__title">{{ item.title }}</h4>
                    <button class="panel__cross" (click)="crossButtonClick(item); stopPropagation($event)" [disabled]="isDisabled(29)">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="panel__comment custom-scrollbar">
                    {{ item.comments }}
                </div>
                <div class="panel__footer">
                    <span class="panel__corner-wrapper">
                        <span class="panel__corner"></span>
                    </span>
                    <button *ngIf="item.inAction" class="panel__button button__bell">
                        <i class="fa-solid fa-bell"></i>
                    </button>
                    <div class="panel__date">
                        <span *ngIf="item.dateRegistrationInSideText != 'מטלה לא פעילה'" class="date__text">{{ item.dateRegistrationText }} </span>
                        <span class="date__number">
                            {{ item.dateRegistrationInSideText }}
                        </span>
                    </div>
                </div>
            </div>

            <div *ngIf="!hasTasks()" class="panel__empty">
                <span class="panel__empty-text">לא נמצאו מטלות, אם ברצונך להוסיף מטלה חדשה השתמש בסמל הפלוס</span>
                <span class="panel__empty-image panel__empty-image-task"></span>
            </div>
        </p-tabPanel>
    </p-tabView>
</section>

<p-dialog
    [ngClass]="{ 'custom-dialog': isConfirmDialogVisible }"
    styleClass="modal modal_type_confirm"
    [(visible)]="isConfirmDialogVisible"
    header="שימו לב!"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div class="modal__text">{{ confirmDialogText }}</div>
    <div class="modal__footer">
        <button *ngIf="actionSelection==1" class="button button_size_small button_theme_main" (click)="closeConfirmDialog(true)">להפוך</button>
        <button *ngIf="actionSelection==2" class="button button_size_small button_theme_main" (click)="closeConfirmDialog(true)">מחיקה</button>
        <button class="button button_size_small button_theme_gray-line" (click)="closeConfirmDialog(false)">בטל</button>
    </div>
</p-dialog>

<p-dialog
    [ngClass]="{ 'custom-dialog': isAddingOrEditingComment }"
    styleClass="modal modal_purpose_comment"
    [(visible)]="isAddingOrEditingComment"
    [header]="commentDialogTitle"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div>
        <div class="input-wrapper input-wrapper_with-label">
            <span class="input-label">נושא</span>
            <input class="input" [(ngModel)]="newCommentTitle" type="text" placeholder="תן כותרת להערה..." autocomplete="off" />
        </div>

        <div class="input-wrapper input-wrapper_with-label input-wrapper_type_textarea">
            <span class="input-label">תיאור</span>
            <textarea class="input" [(ngModel)]="newCommentText" placeholder="הוסף הערות..." autocomplete="off"></textarea>
        </div>
    </div>

    <div class="modal__footer">
        <div class="modal__footer-buttons">
            <button
                class="button button_size_small button_theme_main"
                [disabled]="isNewCommentTextEmpty()"
                (click)="closeAddOrEditCommentDialog(true)"
            >
                שמירה
            </button>
            <button class="button button_size_small button_theme_gray-line" (click)="closeAddOrEditCommentDialog(false)">בטל</button>
        </div>

        <button class="button__color" (click)="colorButtonClick()">
            <span class="button__color-label">בחר צבע להערה</span>
            <!-- <img class="button__color__icon" src="/assets/img/color-picker.svg" /> -->
            <span class="button__color-icon" [ngStyle]="{ 'background-color': chosenColor }"></span>
        </button>

        <div class="colors-wrapper" [ngClass]="{ 'colors-wrapper_visible': isColorsVisible }" (click)="closeColorPicker()">
            <div class="colors" (click)="stopPropagation($event)">
                <button class="color" *ngFor="let item of colors" [ngStyle]="{ 'background-color': item }" (click)="closeColorPicker(item)"></button>
            </div>
        </div>
    </div>
</p-dialog>

<p-dialog
    [ngClass]="{ 'custom-dialog': isAddingOrEditingTask }"
    styleClass="modal modal_purpose_task"
    [(visible)]="isAddingOrEditingTask"
    [header]="taskDialogTitle"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div>
        <div class="modal__selects">
            <div class="input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select">
                <span class="input-label">נושא</span>
                <select class="input" [(ngModel)]="importanceOption">
                    <option *ngFor="let item of importance" [value]="item.id">{{ item.textWarn }}</option>
                </select>
            </div>

            <div class="input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select">
                <span class="input-label">אחראי</span>
                <select class="input" [(ngModel)]="workerOption">
                    <option *ngFor="let item of workers" [value]="item.saparId">{{ item.saparName }}</option>
                </select>
            </div>
        </div>

        <div class="input-wrapper input-wrapper_with-label input-wrapper_type_textarea">
            <span class="input-label">תיאור</span>
            <textarea class="input" [(ngModel)]="newTaskText" placeholder="הוסף הערות..." autocomplete="off"></textarea>
        </div>

        <h4 class="modal__title">?מתי להקפיץ את המטלה</h4>

        <div class="modal__options">
            <div class="input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select">
                <span class="input-label">הזכר לי</span>
                <select class="input" [(ngModel)]="newTaskPeriodType" (change)="periodTypeChange()">
                    <option value="1">בעוד מספר דקות</option>
                    <option value="2">בעוד מספר שעות</option>
                    <option value="3">בעוד מספר ימים</option>
                    <option value="4">בעוד מספר שבועות</option>
                    <option value="5">בעוד מספר חודשים</option>
                    <option value="6">בתאריך מדוייק</option>
                </select>
            </div>

            <div *ngIf="newTaskPeriodType == 1">
                <div class="input-wrapper input-wrapper_with-label input-wrapper_type_range">
                    <span class="input-label">בחר מספר דקות</span>
                    <div class="range">
                        <button class="range__button range__button_plus" (click)="timeValueIncrement()">
                            <i class="fa-regular fa-plus"></i>
                        </button>
                        <input
                            class="input"
                            [(ngModel)]="newTaskTimeValue"
                            (focus)="onRangeFocus($event.target)"
                            (input)="onRangeChange('newTaskTimeValue', $event.target, 1, null)"
                        />
                        <button class="range__button range__button_minus" (click)="timeValueDecrement()">
                            <i class="fa-regular fa-minus"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div *ngIf="newTaskPeriodType == 2">
                <div class="input-wrapper input-wrapper_with-label input-wrapper_type_range">
                    <span class="input-label">בחר מספר שעות</span>
                    <div class="range">
                        <button class="range__button range__button_plus" (click)="timeValueIncrement()">
                            <i class="fa-regular fa-plus"></i>
                        </button>
                        <input
                            class="input"
                            [(ngModel)]="newTaskTimeValue"
                            (focus)="onRangeFocus($event.target)"
                            (input)="onRangeChange('newTaskTimeValue', $event.target, 1, null)"
                        />
                        <button class="range__button range__button_minus" (click)="timeValueDecrement()">
                            <i class="fa-regular fa-minus"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div *ngIf="newTaskPeriodType == 3">
                <div class="input-wrapper input-wrapper_with-label input-wrapper_type_range">
                    <span class="input-label">בחר מספר ימים</span>
                    <div class="range">
                        <button class="range__button range__button_plus" (click)="timeValueIncrement()">
                            <i class="fa-regular fa-plus"></i>
                        </button>
                        <input
                            class="input"
                            [(ngModel)]="newTaskTimeValue"
                            (focus)="onRangeFocus($event.target)"
                            (input)="onRangeChange('newTaskTimeValue', $event.target, 1, null)"
                        />
                        <button class="range__button range__button_minus" (click)="timeValueDecrement()">
                            <i class="fa-regular fa-minus"></i>
                        </button>
                    </div>
                </div>

                <div class="timepicker-wrapper">
                    <timepicker class="timepicker" [(ngModel)]="newTaskDate" [showMeridian]="false"></timepicker>
                    <span class="timepicker-label">בשעה</span>
                </div>
            </div>

            <div *ngIf="newTaskPeriodType == 4">
                <div class="input-wrapper input-wrapper_with-label input-wrapper_type_range">
                    <span class="input-label">בחר מספר שבועות</span>
                    <div class="range">
                        <button class="range__button range__button_plus" (click)="timeValueIncrement()">
                            <i class="fa-regular fa-plus"></i>
                        </button>
                        <input
                            class="input"
                            [(ngModel)]="newTaskTimeValue"
                            (focus)="onRangeFocus($event.target)"
                            (input)="onRangeChange('newTaskTimeValue', $event.target, 1, null)"
                        />
                        <button class="range__button range__button_minus" (click)="timeValueDecrement()">
                            <i class="fa-regular fa-minus"></i>
                        </button>
                    </div>
                </div>

                <div class="timepicker-wrapper">
                    <timepicker class="timepicker" [(ngModel)]="newTaskDate" [showMeridian]="false"></timepicker>
                    <span class="timepicker-label">בשעה</span>
                </div>
            </div>

            <div *ngIf="newTaskPeriodType == 5">
                <div class="input-wrapper input-wrapper_with-label input-wrapper_type_range">
                    <span class="input-label">בחר מספר חודשים</span>
                    <div class="range">
                        <button class="range__button range__button_plus" (click)="timeValueIncrement()">
                            <i class="fa-regular fa-plus"></i>
                        </button>
                        <input
                            class="input"
                            [(ngModel)]="newTaskTimeValue"
                            (focus)="onRangeFocus($event.target)"
                            (input)="onRangeChange('newTaskTimeValue', $event.target, 1, null)"
                        />
                        <button class="range__button range__button_minus" (click)="timeValueDecrement()">
                            <i class="fa-regular fa-minus"></i>
                        </button>
                    </div>
                </div>

                <div class="timepicker-wrapper">
                    <timepicker class="timepicker" [(ngModel)]="newTaskDate" [showMeridian]="false"></timepicker>
                    <span class="timepicker-label">בשעה</span>
                </div>
            </div>

            <div *ngIf="newTaskPeriodType == 6" class="options__datepicker-wrapper">
                <div class="form__item input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_datepicker">
                    <span class="input-label">בחר תאריך</span>
                    <input
                        class="input"
                        bsDatepicker
                        [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', adaptivePosition: true, isAnimated: true }"
                        [minDate]="minDate"
                        [(ngModel)]="newTaskDate"
                        type="text"
                        placeholder="בחר"
                        autocomplete="off"
                        (keydown.backspace)="datepickerBackspaceEvent()"
                    />
                </div>

                <div class="timepicker-wrapper">
                    <timepicker class="timepicker" [(ngModel)]="newTaskDate" [showMeridian]="false"></timepicker>
                    <span class="timepicker-label">בשעה</span>
                </div>
            </div>
        </div>

        <div *ngIf="!isSaveTaskButtonDisabled()" class="modal__message">
            המטלה תקפוץ ב- {{ getTaskDate("date", true) }} בשעה {{ getTaskDate("time", true) }}
        </div>

        <div *ngIf="isSaveTaskButtonDisabled()" class="modal__message">
            המטלה קפצה ב- {{ getTaskDate("date", true) }} בשעה {{ getTaskDate("time", true) }}
        </div>
    </div>

    <div class="modal__footer">
        <div class="modal__footer-buttons">
            <button
                class="button button_size_small button_theme_main"
                [disabled]="isSaveTaskButtonDisabled()"
                (click)="closeAddOrEditTaskDialog(true)"
            >
                שמירה
            </button>
            <button class="button button_size_small button_theme_gray-line" (click)="closeAddOrEditTaskDialog(false)">בטל</button>
        </div>
    </div>
</p-dialog>

<div
    appHostListenerBeforeUnload
    (componentHasChangedOutput)="this.componentHasChanged = $event"
    [saveData]="saveData"
    [receivedData]="custcard_5"
></div>
